export default __webpack_public_path__ + "static/media/login-bg.aa592dfa.webp";